function CaravanDefaultValueRequestTransformer(Util, jsonMapper, userInputRepository, quoteOptions) {

	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = "{0} at {1} AEST" ;
		var timeFormatted = '4:00PM' ;
		if ( time )
			timeFormatted = moment().tz("Australia/Sydney").format('h:mma');
		return Util.stringFormat(format, moment().tz("Australia/Sydney").format('Do MMM YYYY') , timeFormatted) ;
	}

	var staticValuesMapping = {
		"quoteType": 'Full',
		"productCode": 'QPCCaravanTrailer',
		"caravans.0.financeType": "none",
		"caravans.0.sumInsuredType": "agreed",
		"caravans.0.garageType": "garage",
		"caravans.0.coverType": "comprehensive",
		"caravans.0.specifiedContents": false,
		"caravans.0.existingDamageType": "nodamage",
		"caravans.0.hasCurrentInsurance": false,
		"caravans.0.isEligibleforSDExemption": false,		
		"caravans.0.isCaravanRegistered": true,
		"caravans.0.isCycloneRatedSecurity": false,
		"caravans.0.locationType": "residentialaddress",
		"caravans.0.securityType": "garage",
		"caravans.0.registrationNumber": "RAPID_QUOTE_REGNUMBER",
		"caravans.0.chassisNumber": "Not Supplied",
		"caravans.0.isCaravanOnNonRetractableJacks": false,
		"caravans.0.isCaravanConnectedToPlumbing": false,
		"caravans.0.isPermResidence": false,
		"caravans.0.caravanUsageType": "private",
		"caravans.0.contentsCover": true,
		"caravans.0.purchaseMonthYear": moment().tz("Australia/Sydney").format('YYYY-MM'),
		"caravans.0.yearsContinuousInsurance": "0",
		"caravans.0.garageAddress.addressType": "postal",
		"caravans.0.drivers.*.driver.licenceType": "full",
		"caravans.0.drivers.*.driver.yearsLicenced": "6",
		"caravans.0.drivers.*.driver.hasConviction": false,
		"caravans.0.drivers.*.driver.hasClaim": false,
		"caravans.0.drivers.*.driver.hasInfringement": false,
		"caravans.0.drivers.*.driver.hasLostLicence": false,
		"caravans.0.drivers.*.driver.zeroDemerits": true ,
		"caravans.0.drivers.*.driver.previousInsurer": "none",
		"caravans.0.drivers.*.driver.person.contactType": "person",
		"caravans.0.drivers.*.driver.person.gender": "male",
		"caravans.0.drivers.*.driver.person.firstName": "An@n",
		"caravans.0.drivers.*.driver.person.lastName": "An@nym@us",
		"caravans.0.drivers.*.driver.person.isJustInsured": false,
		"caravans.0.drivers.*.driver.person.dateOfBirth": "01/06/2000",
		"caravans.0.availableCoverTypes" : [
          "comprehensive"
        ],
		"availableSumInsuredTypes": [
          "market",
          "agreed"
        ],
		"caravans.0.excess.standardVehicleExcess": 650,
	    "caravans.0.excess.ageExcessTier1": 1000,
	    "caravans.0.excess.ageExcessTier2": 750,
	    "caravans.0.excess.undeclaredDriverTier2": 500,
	    "caravans.0.excess.inexperiencedDriver": 750,
		"policyHolders.0.mainHolder": true,
		"policyHolders.0.contact.isJustInsured": false,
		"policyHolders.0.contact.contactType": "person",
		"policyHolders.0.contact.dateOfBirth": "01/06/2000",
		// full quote transformation :
        "status" : "Draft",
		"documentDeliveryMethod": 'email',
		"displayStatus": 'Draft',
		"periodStartDateTimeAEDT": formatDateAndTimeTheGuidewireWay(moment(), moment()),
		"periodEndDateTimeAEDT" : formatDateAndTimeTheGuidewireWay(moment().add(1,'years')),
		"channel": 'portal',
		"caravans.0.drivers.*.driverUsage" : "other",
	}

	function transform(intermediateRequest, userInput) {
		var staticValuesMappingNew = ApplyDefaultExcess(userInput);
		var transformedRequest = jsonMapper.setDefault(userInput, staticValuesMappingNew) ;
		return transformedRequest;
	}

	function ApplyDefaultExcess(userInput) {
		var staticValuesMappingNew  = staticValuesMapping;
		var excessValue = quoteOptions.getStateDefaultVoluntaryExcess(userInput.policyAddress.state);
		if(excessValue != null){
			var tempObj = {"caravans.0.excess.voluntaryVehicleExcess": excessValue};
			staticValuesMappingNew = Object.extend(staticValuesMapping, tempObj);
		}
		return staticValuesMappingNew;
	}

	return {
		transform: transform
	}
}
